import { useContext } from 'react'
import { Helmet } from 'react-helmet-async'

import { faIdCard } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Columns, DashboardModule, LoadingModule,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import { generateUrls } from '@hooks/useLoginSession'
import useLoginSessions from '@hooks/useLoginSessions'

import ListBlankState from '@components/ListBlankState'
import PageFilterModule from '@components/PageFilterModule'
import PageHeader from '@components/PageHeader'

import LoginSessionsTable from '../LoginSessionsTable'

const buildPageFilterFields = () => {
  const boxProps = { marginBottom: 'large' }

  return [
    {
      component: 'EntitySelector',
      componentProps: {
        boxProps,
        entityKey: 'users',
        entityTitleKey: 'full_name',
      },
      key: 'user_id',
    },
  ]
}

interface PageContentProps {
  pageFilters: {
    [key: string]: any,
  },
}

const PageContent = (props: PageContentProps) => {
  const { pageFilters } = props

  const loginSessionsPayload = useLoginSessions({
    filters: pageFilters,
    performHttpRequests: true,
    requestOptions: { include_login_session_user: true },
  })

  const {
    callbacks: { loadMore },
    canLoadMore,
    filteredLoginSessions,
    filteredLoginSessionsCount,
    hasFilteredLoginSessions,
    loading,
  } = loginSessionsPayload

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      resetFilters,
      updateFilters,
    },
    defaultFilters,
  } = pageContext

  const { loginSessionsIndexUrl } = generateUrls()

  return (
    <>
      <Helmet>
        <title>Login Sessions | Realhub</title>
      </Helmet>

      <PageHeader
        activeTabBarItemKey="loginSessions"
        tabBarItems={[
          {
            href: loginSessionsIndexUrl,
            icon: faIdCard,
            key: 'loginSessions',
            title: 'Login Sessions',
          },
        ]}
        title="Login Sessions"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <LoadingModule loading={loading} times={3} />

            {!loading && !hasFilteredLoginSessions && <ListBlankState />}

            {!loading && hasFilteredLoginSessions && (
              <DashboardModule title="Login Sessions">
                <Box flexDirection="column">
                  <Box flexDirection="column">
                    <LoginSessionsTable loginSessions={filteredLoginSessions} />
                  </Box>

                  <DashboardModule.LoadMoreFooter
                    callbacks={{ loadMore }}
                    canLoadMore={canLoadMore}
                    entityCount={filteredLoginSessionsCount}
                    loading={loading}
                  />
                </Box>
              </DashboardModule>
            )}
          </Columns.Main>

          <Columns.Sidebar>
            <PageFilterModule
              callbacks={{ resetFilters, updateFilters }}
              defaultFilters={defaultFilters}
              // @ts-expect-error TS2322
              filterFields={buildPageFilterFields()}
              pageFilters={pageFilters}
              title="Filters"
            />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
